import React, { useEffect, useState, Fragment } from 'react';
import { PageHeader } from '../../../Common';
import services from '../services';
import $ from 'jquery';
import { makeStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import StarIcon from '@material-ui/icons/Star';
import { Switch, Select } from '@material-ui/core';
import MessageModal from '../../../UI/Modal/MessageModal';
import tokenService from '../../../Common/tokenDecoder';
import { LoadingSpinerComponent } from '../../../Common/loader';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: 1500,
        backgroundColor: theme.palette.background.paper,
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
}));
export function RolePermissionListing(props) {
    const classes = useStyles();
    const { data } = props.location;
    const [title, setTitle] = useState("Change Role Permissions")
    const [permission, setPermission] = useState([]);
    const [screen, setScreen] = useState([]);
    const [unmodifiedPermission, setUnmodifiedPermission] = useState([]);
    const [currentRoleID, setCurrentRoleID] = useState();
    const [buttonName, setButtonName] = useState("Save");
    const [clearPermission, setClearPermission] = useState({
        unmodifiedList: unmodifiedPermission,
        modifiedList: permission,
        roleID: data.aspNetRoleId
    });
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    })
    const [isSaveDisable, setIsSaveDisable] = useState(false);

    useEffect(() => {
        setCurrentRoleID(data.aspNetRoleId);
        getAllPermission();
    }, []);

    useEffect(() => {
      if(data.roleLevel != 1 && data.aspNetRoleId == tokenService.getRoleFromToken()){
        setIsSaveDisable(true);
      }
    }, []);

    function handlePermissionChange(permissionID, screenID) {
        var modifiedPermission = [...permission];
        modifiedPermission.forEach(p => {
            if (p.permissionID == permissionID) {
                p.isAssigned = !p.isAssigned
            }
        });
        setPermission(modifiedPermission);

        var count = 0;
        var trueCount = 0;
        var updateCount = [...permission];
        updateCount.forEach(p => {
            if (p.screenID == screenID) {
                count++;
                if (p.isAssigned == true) {
                    trueCount++;
                }
            }
        });
        setPermission(updateCount);

        var updateScreen = [...screen];
        updateScreen.forEach(s => {
            if (s.screenID == screenID) {
                if (trueCount == count) {
                    s.isOpen = true;
                } else {
                    s.isOpen = false;
                }
            }
        });
        setScreen(updateScreen);
    }

    function handleScreenChange(screenID) {
        var updateScreen = [...screen];
        updateScreen.forEach(s => {
            if (s.screenID == screenID) {
                s.isOpen = !s.isOpen;
            }
        });
        setScreen(updateScreen);

        var checkAllScreen = [...screen];
        checkAllScreen.forEach(s => {
            if (s.screenID == screenID) {
                if (s.isOpen) {
                    var updateCount = [...permission];
                    updateCount.forEach(p => {
                        if (p.screenID == screenID) {
                            p.isAssigned = true;
                        }
                    });
                    setPermission(updateCount);
                } else {
                    var permissionList = [...permission];
                    permissionList.forEach(p => {
                        if (p.screenID == screenID) {
                            p.isAssigned = false;
                        }
                    })
                    setPermission(permissionList);
                }
            }
        });
    }

    function handleClickCheckbox(e) {
        e.stopPropagation();
    }

    async function getAllPermission() {
        var token = tokenService.getUserDetailsFromToken();
        var permissionData = await services.getPermissionNameAndScreenNameForCheckbox(token.roleID, data.aspNetRoleId);
        setScreen(permissionData.data.screens);
        setPermission(permissionData.data.permissions);
        setUnmodifiedPermission(permissionData.data.unmodifiedPermissions);
    }

    async function handleSave(e) {
        e.preventDefault();
        const response = await services.saveRolePermission(unmodifiedPermission, permission, data.aspNetRoleId);
        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message });
        afterSuccessfulyChanged(response.statusCode);
        setIsSaveDisable(true);
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            clearState()
            setTimeout(() => {
                props.history.push({ pathname: '/role' })
            }, 1500);
        }
    }

    function clearState() {
        setClearPermission({
            ...clearPermission,
            unmodifiedList: null,
            modifiedList: null,
            roleID: null
        });
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title={title}
                            isButtonEnable={true}
                            buttonText="Back to Listing"
                            path="/role"
                        />
                        <form onSubmit={(e) => handleSave(e)}>
                            <div className="card-body">
                                <div className="table-responsive row-top-gap">
                                    {screen.map(s => {
                                        return (
                                            <ExpansionPanel>
                                                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                                    <Typography className={classes.heading} >
                                                        <Checkbox
                                                            color="primary"
                                                            onChange={() => handleScreenChange(s.screenID)}
                                                            checked={s.isOpen}
                                                            onClick={e => handleClickCheckbox(e)}
                                                        />
                                                        <label>{s.screenName}</label>
                                                    </Typography>
                                                </ExpansionPanelSummary>
                                                <ExpansionPanelDetails>
                                                    <Typography>
                                                        {permission.map(p => {
                                                            if (p.screenID == s.screenID) {
                                                                return (
                                                                    <Fragment>
                                                                        <ListItem button className={classes.nested}>
                                                                            <ListItemIcon>
                                                                                <StarIcon/>
                                                                            </ListItemIcon>
                                                                            <ListItemText primary={p.permissionName} />
                                                                            <Switch
                                                                                color="primary"
                                                                                checked={p.isAssigned}
                                                                                label={p.permissionName}
                                                                                onChange={() => handlePermissionChange(p.permissionID, p.screenID)}
                                                                            />
                                                                        </ListItem>
                                                                    </Fragment>
                                                                );
                                                            }
                                                        })}
                                                    </Typography>
                                                </ExpansionPanelDetails>
                                            </ExpansionPanel>
                                        );
                                    })}

                                </div>
                            </div>
                            <div className="card-footer">
                                <input
                                    type="submit"
                                    className="btn btn-primary"
                                    value={buttonName}
                                    disabled = {isSaveDisable}
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}


